import { Typography } from "@aircall/tractor";
import type { PropsWithChildren } from "react";

import type { PlaygroundSubSectionTitleProps } from "./PlaygroundSubSectionTitle.decl";

export function PlaygroundSubSectionTitle({
  children,
  ...props
}: PropsWithChildren<PlaygroundSubSectionTitleProps>) {
  return (
    <Typography variant="headingMediumXS" {...props}>
      {children}
    </Typography>
  );
}
